export default {
  // Transition slide side. Possible values are 'slide-left', 'slide-top', 'slide-right' and 'slide-bottom'
  transition: 'slide-left'
}
